// extracted by mini-css-extract-plugin
export var active = "_9c-7";
export var container = "_9c-0";
export var evenWidth = "_9c-4";
export var large = "_9c-5";
export var outlet = "_9c-8";
export var slide = "_9c-2";
export var small = "_9c-6";
export var tab = "_9c-3";
export var tabs = "_9c-1";